import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

// ----------------------------------------------------------------------

const RouterLink = forwardRef(({ href, ...other }: any, ref) => (
  <Link ref={ref} to={href} {...other} />
));

export default RouterLink;
